import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=b31636da&"
import script from "./AccountMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./AccountMenu.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports